import script from "./FilterCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterCategory.vue?vue&type=script&setup=true&lang=js"

import "./FilterCategory.vue?vue&type=style&index=0&id=5e71864a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e71864a"]])

export default __exports__